// dashboard js
//Side menu 
jQuery(document).ready(function() {
    jQuery('#site-menu li.menu-item').hover(
        function () {
            jQuery(this).find('.tooltip').fadeIn(100);
        },
        function () {
            jQuery(this).find('.tooltip').fadeOut(100);
        }
    );
    jQuery('.form-accordion legend').click(
        function () {
            jQuery(this).parents('.form-accordion').find('.ginput_container_checkbox').toggle();
        }
    );
});

// force active menus
jQuery(window).load(function() {
    //connect page
    if ( jQuery('body').hasClass('bbpress')) {
        jQuery('li.connect-menu').addClass('current-menu-item current-page-item active');
    }
    //network page
    if ( jQuery('body').hasClass('page-id-828')) {
        jQuery('li.connect-menu').addClass('current-menu-item current-page-item active');
    } 
    //content library page
    if ( jQuery('body').hasClass('page-id-871')) {
        jQuery('li.library-menu').addClass('current-menu-item current-page-item active');
    } 
    //policies page
    if ( jQuery('body').hasClass('page-id-611')) {
        jQuery('li.library-menu').addClass('current-menu-item current-page-item active');
    }
});

//Top button
jQuery(window).scroll(function() {
    var height = jQuery(window).scrollTop();
    if (height > 100) {
        jQuery('#back2Top').fadeIn();
    } else {
        jQuery('#back2Top').fadeOut();
    }
});
jQuery(document).ready(function() {
    jQuery('#back2Top').click(function(event) {
        event.preventDefault();
        jQuery("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
    });
});

//sub tabs
const tabs = document.querySelector(".tab-pages");
const tabButton = document.querySelectorAll("ul.sub-menu li a");
const contents = document.querySelectorAll(".tab-page");

$(tabs).on('click', function(e){
    const id = e.target.dataset.id;
    if (id) {
        tabButton.forEach(btn => {
        btn.classList.remove("active");
        });
        e.target.classList.add("active");

        contents.forEach(content => {
        content.classList.remove("active");
        });
        const element = document.getElementById(id);
        element.classList.add("active");
    }
});

//faq 
jQuery('.faq-nav li a').first().addClass('selected');
jQuery('.faq-nav li a').click(function(){
    jQuery('.faq-nav li a').removeClass('selected');
    jQuery(this).addClass('selected');

});
// jQuery(window).scroll(function() {
//     var height = jQuery(window).scrollTop();
//     if (height > 420) {
//         jQuery('.faq-nav').addClass('sticky');
//     } else {
//         jQuery('.faq-nav').removeClass('sticky');
//     }
// });

// jQuery('.faq-questions .question-link').click(function(){
//     //jQuery(this).hide();
//     if (jQuery(this).hasClass('deactive')) {
//         jQuery(this).removeClass('deactive');
//         jQuery(this).addClass('active');
//         let question = jQuery(this).parents('.question').first();
//         jQuery(question).find('.answer').slideDown(100);
//     } else {
//         jQuery(this).removeClass('active');
//         jQuery(this).addClass('deactive');
//         let question = jQuery(this).parents('.question').first();
//         jQuery(question).find('.answer').slideUp(100);

//     }
// });

//jQuery(document).ready(function() {
    // var question = jQuery('.as-accordion');
    // var noResults = jQuery('.as-accordion.as-d-none');
    // //question.closest('.section').addClass('show');

    // if(question.hasClass('as-d-none')){
    //     jQuery(this).closest('.section').removeClass('show');
    // } else {
    //     jQuery(this).closest('.section').toggleClass('show');
    // }
//});

//Build Accordion
jQuery('.resource-links h3').on('click', function(){
    let parent = jQuery(this).parents('.resource-links');
    jQuery(parent).find('ul').toggle('show');
    jQuery(parent).find('h3').toggleClass('resource-active');
});

//Zoom in and out
var zoom = 1;
jQuery('.zoom-in').on('click', function(){
    zoom += 0.1;
    let content = jQuery(this).parents('.nestable-tab-page');
    jQuery(content).find('.zoom-content').css('transform', 'scale(' + zoom + ')');
    //jQuery(content).find('.zoom-target').css('zoom', '' + zoom + '');
    //jQuery(content).find('.zoom-content').attr('class', 'zoom-target');
    jQuery(content).find('zoom-content').addClass('zoom-' + zoom + '');
    jQuery(content).find('.zoom-content').removeClass('zoom-1');
    jQuery(content).find('table').removeClass('sticky-left-col sticky-thead');
    jQuery(content).find('table .sticky-col').addClass('sticky-col-zoom');
    //enable and disable buttons
    jQuery(content).find('button.zoom-out').prop('disabled', false);
    if (jQuery(content).find('.zoom-content').hasClass('zoom-1.7000000000000006')) {
        jQuery(content).find('button.zoom-in').prop('disabled', true);
    } 
});

jQuery('.zoom-reset').on('click', function(){
    zoom = 1;
    let content = jQuery(this).parents('.nestable-tab-page');
    jQuery(content).find('.zoom-content').css('transform', 'scale(' + zoom + ')');
    //jQuery(content).find('.zoom-target').css('zoom', '' + zoom + '');
    jQuery(content).find('.zoom-content').attr('class', 'zoom-content zoom-1');
    jQuery(content).find('table').addClass('sticky-left-col sticky-thead');
    jQuery(content).find('table .sticky-col').removeClass('sticky-col-zoom');
    //jQuery(content).find('.zoom-target').addClass('zoom-' + zoom + '');
    //enable buttons
    jQuery(content).find('button.zoom-in, button.zoom-out').prop('disabled', false);
});
jQuery('.zoom-out').on('click', function(){
    zoom -= 0.1;
    let content = jQuery(this).parents('.nestable-tab-page');
    jQuery(content).find('.zoom-content').css('transform', 'scale(' + zoom + ')') ;
    //jQuery(content).find('.zoom-target').css('zoom', '' + zoom + '');
    //jQuery(content).find('.zoom-content').attr('class', 'zoom-target');
    jQuery(content).find('.zoom-content').addClass('zoom-' + zoom + '');
    jQuery(content).find('.zoom-content').removeClass('zoom-1');
    jQuery(content).find('table').removeClass('sticky-left-col sticky-thead');
    jQuery(content).find('table .sticky-col').addClass('sticky-col-zoom');
    //enable and disable buttons
    jQuery(content).find('button.zoom-in').prop('disabled', false);
    if (jQuery(content).find('.zoom-content').hasClass('zoom-0.30000000000000016')) {
        jQuery(content).find('button.zoom-out').prop('disabled', true);
    } 
    
});

//Additional Assessment form 
jQuery(document).ready(function() {
    jQuery(document).bind('gform_post_render', function(e) {
        e.preventDefault();
        jQuery('.add-assessment-form .gform_page_1 input[checked="checked"]').parents('.gchoice').addClass('selected');
        jQuery('.add-assessment-form .gform_page_1 input[type="radio"]').change( function(){
               if (jQuery(this).is(':checked') ) {
                    jQuery(this).parents('.gchoice').addClass('selected').siblings('.gchoice').removeClass('selected');

               } else {
                    jQuery(this).parents('.gchoice').removeClass('selected');
               }
        });
    });
    jQuery('td.options i').click(function() {
        jQuery('ul.option-dropdown').hide();
        jQuery('td.options i').removeClass('active');
        jQuery(this).parents('td.options').find('ul.option-dropdown').show();
        jQuery(this).parents('td.options').find('i').addClass('active');
    });
});

// Hub Forum

jQuery(document).ready(function() {
    jQuery('.bbp-reply-to-link, .bbp-topic-reply-link').attr('title', 'reply');

    //for the 'Create a Discussion' for All Hub Members
    jQuery( "a[href^='#add-topic-all']").click(function(e) {
        e.preventDefault();

        var position = jQuery('#add-topic-form').position();
        //console.log(position);
       
        $("body, html").animate({
            scrollTop: 725
        }, 500, 'linear' );
    });
});

